import React from 'react';
import { connect } from 'react-redux';
import { Row, Button, Col, ListGroupItem, Panel, ListGroup, Alert } from 'react-bootstrap';
import { SubmissionError } from 'redux-form';
import moment from 'moment';
import { updateUser } from '../../../actions/login';
import UpdateUserForm from './form';
import { withRouter } from 'react-router';
import './styles.css';

class UpdateUser extends React.Component<{}> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = val => {
    return this.props.updateUser(this.props.user.id, val).then(res => {
      if (this.props.updateUserState.hasFailed) {
        throw new SubmissionError({ _error: this.props.updateUserState.errorMessage.message });
      }
    });
  };

  render() {
    const initialValues = {
      firstname: this.props.user.forename,
      lastname: this.props.user.surname,
      username: this.props.user.username
    };

    const redirectUrl = process.env.REACT_APP_LEGACY_BOOKING_URL;

    const { outboundData, inboundData, user, updateUserState } = this.props;
    return (
      <div>
        <Col>
          <Panel>
            <Panel.Heading>
              <h3 className='centered'>
              {localStorage.getItem("cnbk") === "true"
                  ? "Booking Complete"
                  : "Request Received"}
              
              </h3>
            </Panel.Heading>
            <Panel.Body>
              {this.props.resultText.show ? (
                <Col className="resultText">
                  <Alert bsStyle="success">
                    {<h4>{this.props.resultText.title}</h4>}
                    <p>{this.props.resultText.message}</p>
                  </Alert>
                </Col>
              ) : null}
              {user.isGuest ? (
                <Col xs={12} md={6} className="text-center">
                  <UpdateUserForm
                    initialValues={initialValues}
                    onSubmit={r => this.handleSubmit(r)}
                    updateUserState={updateUserState}
                  />
                </Col>
              ) : (
                <Col xs={12} md={6} className="text-center">
                  <a href={redirectUrl}>
                    <Button bsSize="large" bsStyle="success">
                      Click here to view your bookings
                    </Button>
                  </a>
                </Col>
              )}
              <Col xs={12} md={6} className="text-center">
                <Panel className="outbound-panel" >
                  <Panel.Heading>
                    <h4>
                      <strong>Outbound Transfer</strong>
                    </h4>
                  </Panel.Heading>
                  <ListGroup fill >
                    <ListGroupItem>
                      <Row>
                        <Col xs={4} className="text-left">
                          {outboundData.fromDestination.name}
                        </Col>
                        <Col xs={2} className="text-center">
                          &gt;
                        </Col>
                        <Col xs={6} className="text-left">
                          {outboundData.toDestination.name}
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Departing Date</Col>
                        <Col xs={6}>{moment(outboundData.date).format('Do MMMM YYYY')}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Flight Time</Col>
                        <Col xs={6}>{outboundData.time}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Adults</Col>
                        <Col xs={6}>{outboundData.adults}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Children</Col>
                        <Col xs={6}>{outboundData.children.length}</Col>
                      </Row>
                    </ListGroupItem>
                  </ListGroup>
                </Panel>
                {inboundData ? (
                  <Panel className="return-panel">
                    <Panel.Heading>
                      <h4>
                        <strong>Return Transfer</strong>
                      </h4>
                    </Panel.Heading>
                    <ListGroup fill >
                      <ListGroupItem>
                        <Row>
                          <Col xs={4} className="text-left">
                            {inboundData.fromDestination.name}
                          </Col>
                          <Col xs={2} className="text-center">
                            &gt;
                          </Col>
                          <Col xs={6} className="text-left">
                            {inboundData.toDestination.name}
                          </Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Departing Date</Col>
                          <Col xs={6}>{moment(inboundData.date).format('Do MMMM YYYY')}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Flight Time</Col>
                          <Col xs={6}>{inboundData.time}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Adults</Col>
                          <Col xs={6}>{inboundData.adults}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Children</Col>
                          <Col xs={6}>{inboundData.children.length}</Col>
                        </Row>
                      </ListGroupItem>
                    </ListGroup>
                  </Panel>
                ) : null}
              </Col>
            </Panel.Body>
          </Panel>
        </Col>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      updateUserState: state.login.updateUser,
      user: state.user,
      outbound: state.basket.data.transfers[0]
    }),
    { updateUser }
  )(UpdateUser)
);



// WEBPACK FOOTER //
// ./src/containers/CompleteBooking/PersonalDetails/index.js